import { Xmark } from '@peacecover/icon';
import ProfileAvatar from '../../my-page/components/ProfileAvatar';
import type { components } from '../../../types/schema';

type ApiV1CastRelationship = components['schemas']['ApiV1CastRelationship'];

interface PreviewCastRelationshipProps {
  castRelationship: ApiV1CastRelationship | null;
  iconClassName?: string;
  className?: string;
}

const PreviewCastRelationship = ({
  castRelationship,
  iconClassName = '',
  className = ''
}: PreviewCastRelationshipProps) => {
  const { personA, personB } = castRelationship ?? {};
  return (
    <div className={`flex items-center gap-[7px] ${className}`}>
      <div className="flex items-center gap-[6px]">
        <ProfileAvatar
          thumbnailUrl={personA?.thumbnailUrl}
          widthAndHeight="27px"
          svgWidthAndHeight="27px"
        />
        <p className="text-[13px] font-medium leading-[15px]">{personA?.name ?? ''}</p>
      </div>
      <Xmark size={12} className={`text-main-dark-3 ${iconClassName}`} />
      <div className="flex items-center gap-[6px]">
        <ProfileAvatar
          thumbnailUrl={personB?.thumbnailUrl}
          widthAndHeight="27px"
          svgWidthAndHeight="27px"
        />
        <p className="text-[13px] font-medium leading-[15px]">{personB?.name ?? ''}</p>
      </div>
    </div>
  );
};

export default PreviewCastRelationship;
